import {TextButtonView} from '../../ui_canvas_engine/TextButtonView'
import {CA} from '../../analytics/Analytics'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {AnalyticEventCategory, AnalyticEventType, AnalyticEventValue} from '../../../../../shared/entity_datas/EntityDatas'
import {AsyncAssetLoader} from '../../AsyncAssetLoader'
import {PIXI} from '@colonist/pixi'
import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {UIImagePathController} from '../../UIEnums.ts'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {LobbyImage} from '@colonist/types'

export class UIGameEndShareButtonController {
    readonly button: TextButtonView
    private buttonIcon: PIXI.Sprite

    constructor(x: number, y: number, w: number, h: number, container: SectionBgView, clickAction: () => void) {
        this.button = new TextButtonView(x, y, w, h, container)
        this.button.viewContainer.drawRoundedBg(UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bg_button_green_cta))
        void this.setButtonContent()

        this.button.updateAction(() => {
            clickAction()
            UIGameEndShareButtonController.sendShareButtonClickAnalytic()
        })
    }

    private async setButtonContent() {
        this.setButtonText()
        await this.setButtonIcon()
        this.layoutButtonContent()

        this.button.viewContainer.addChild(this.buttonIcon)
    }

    private setButtonText() {
        this.button.updateText({key: 'strings:game.endGame.cornerButton.share'})

        const textView = this.button.getTextView()
        textView.removeBold()
    }

    private async setButtonIcon() {
        if(this.buttonIcon != undefined) return

        const texture = await UIGameEndShareButtonController.getButtonTexture()
        this.buttonIcon = new PIXI.Sprite(texture)
        this.buttonIcon.width = this.button.viewContainer.width / 6
        this.buttonIcon.height = this.button.viewContainer.height / 2
    }

    private static async getButtonTexture() {
        const icon = UIUtilsEjsVariables.isUserOnDiscord ? LobbyImage.DiscordIcon : LobbyImage.Share
        return await AsyncAssetLoader.getAsyncTexture(UIImagePathController.getImgPath(icon))
    }

    private layoutButtonContent() {
        const textView = this.button.getTextView()
        const padding = 5
        const totalContentWidth = textView.width + this.buttonIcon.width + padding

        const startX = (this.button.width - totalContentWidth) / 2
        textView.x = startX
        this.buttonIcon.x = startX + textView.width + padding
        this.buttonIcon.y = (this.button.height - this.buttonIcon.height) / 2
    }

    private static sendShareButtonClickAnalytic() {
        const endGameShareEvent: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.EndGameShareButton,
            category: AnalyticEventCategory.Virality,
            floatValue: AnalyticEventValue.EndGameShareButton,
        }
        void CA.sendAnalyticEventOnce(endGameShareEvent)
    }
}
